import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InfosLogistique from './InfosLogistique';
import withLoader from 'components/Shared/withLoader';
import { invalidateReclamationInfosLogistique } from 'store/reclamation/detailsActions';
import { fetchReclamationInfosLogistiqueIfNeeded } from 'store/reclamation/detailsActions';

import { CategorieCodes } from 'constants.js';


const InfosLogistiqueWithLoader = withLoader(InfosLogistique);

class InfosLogistiqueContainer extends React.Component {

    componentDidMount() {
        this.props.fetchReclamationInfosLogistiqueIfNeeded(this.props.reclamationId, this.props.pieceCle);
    }

    componentDidUpdate(prevProps) {
        // Changement de réclamation OU de pièce/BL actif (onglets multi-BL) → on recharge.
        if (prevProps.reclamationId !== this.props.reclamationId || prevProps.pieceCle !== this.props.pieceCle) {
            this.props.invalidateReclamationInfosLogistique();
            this.props.fetchReclamationInfosLogistiqueIfNeeded(this.props.reclamationId, this.props.pieceCle);
        }
    }

    render() {

        return (
            <InfosLogistiqueWithLoader
                isLoading={this.props.isLoading}
                infosLogistique={this.props.infosLogistique}
                afficheSuiviColisDetaille={this.props.afficheSuiviColisDetaille}
            />
        );
    }
}

InfosLogistiqueContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired,
    // Clé du BL à afficher (dossier multi-BL depuis commande) ; null = première pièce.
    pieceCle: PropTypes.string
};

const mapStateToProps = state => ({
    isLoading: state.reclamation.details.isInfosLogistiqueLoading,
    infosLogistique: state.reclamation.details.infosLogistique,
    afficheSuiviColisDetaille: state.reclamation.details.item.categorie.code !== CategorieCodes.SouffranceTransporteur
});

const mapDispatchToProps = dispatch => ({
    invalidateReclamationInfosLogistique: () => dispatch(invalidateReclamationInfosLogistique()),
    fetchReclamationInfosLogistiqueIfNeeded: (id, pieceCle) => dispatch(fetchReclamationInfosLogistiqueIfNeeded(id, pieceCle))
});

export default connect(mapStateToProps, mapDispatchToProps)(InfosLogistiqueContainer);